/* Bedtextielonline (Claude): menu op gsm en tablet in dezelfde opbouw als het uitklapmenu op de computer.
   - elke rij krijgt de foto van de categorie (uit het uitklapmenu op de computer, anders van het eerste product)
   - 'Nieuw' en 'Uitverkoop' verbergen, net als op de computer
   - bovenaan elk paneel de tegels van de computer (Alle hoeslakens ...), dubbele links eruit
   - groepen met een eigen collectie (Hoeslakens, Lakensets ...) krijgen bovenaan 'Bekijk alles'; alleen de eerste groep staat open
   - onderaan een hulpblok: mail, contactpagina en de zekerheden (geen telefoonnummer)
   Vormgeving in assets/btol-menu.css */
(function () {
  var PIJL = '<svg viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="m3 9 4-4-4-4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>';
  var VINK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  function tekst(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function pad(u) { try { var x = new URL(u, location.origin); return x.pathname + x.search; } catch (e) { return u || ''; } }
  function fotoVan(img) { return img ? (img.currentSrc || img.getAttribute('src') || '') : ''; }

  function maakFoto(src) {
    var s = document.createElement('span');
    s.className = 'btol-mob__foto';
    s.setAttribute('aria-hidden', 'true');
    if (src) { var i = document.createElement('img'); i.src = src; i.alt = ''; i.loading = 'lazy'; s.appendChild(i); }
    return s;
  }

  function vulMetProductfoto(span, href) {
    if (!href || href.indexOf('/collections/') !== 0) return;
    fetch(href.split('?')[0] + '/products.json?limit=1').then(function (r) { return r.json(); }).then(function (d) {
      var p = d && d.products && d.products[0];
      var src = p && p.images && p.images[0] && p.images[0].src;
      if (!src || span.querySelector('img')) return;
      var i = document.createElement('img'); i.alt = ''; i.loading = 'lazy';
      i.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      span.appendChild(i);
    }).catch(function () {});
  }

  function bouw() {
    var side = document.getElementById('sidebar-menu');
    if (!side || side.__btolMob) return;
    var hoofd = side.querySelector('.header-sidebar__main-panel .header-sidebar__linklist');
    if (!hoofd) return;
    side.__btolMob = true;

    /* gegevens van het uitklapmenu op de computer, per titel */
    var desk = {};
    document.querySelectorAll('.header__primary-nav-item').forEach(function (li) {
      var titel = li.getAttribute('data-title') || tekst(li.querySelector('summary')) || tekst(li.querySelector(':scope > a')) || tekst(li.querySelector('a'));
      var mm = li.querySelector('.btol-mm');
      var info = { href: '', tegels: [], groepen: {} };
      var a0 = li.querySelector('summary a[href], :scope > a[href]');
      if (a0 && a0.getAttribute('href')) info.href = a0.getAttribute('href');
      if (mm) {
        mm.querySelectorAll('.btol-mm__tegel').forEach(function (t) {
          info.tegels.push({ href: t.getAttribute('href'), titel: tekst(t.querySelector('strong')), sub: tekst(t.querySelector('small')), foto: fotoVan(t.querySelector('img')) });
        });
        mm.querySelectorAll('a.btol-mm__kop').forEach(function (k) { info.groepen[tekst(k).toLowerCase()] = k.getAttribute('href'); });
      }
      desk[titel.toLowerCase()] = info;
    });

    /* eerste niveau */
    Array.prototype.forEach.call(hoofd.children, function (li) {
      var knop = li.querySelector(':scope > .header-sidebar__linklist-button');
      if (!knop) return;
      var titel = tekst(knop);
      var t = titel.toLowerCase();
      if (t === 'nieuw' || t.indexOf('uitverkoop') === 0) { li.classList.add('btol-mob--verborgen'); return; }
      var info = desk[t] || { href: '', tegels: [], groepen: {} };
      var src = info.tegels[0] && info.tegels[0].foto;
      var foto = maakFoto(src);
      knop.insertBefore(foto, knop.firstChild);
      if (!src) vulMetProductfoto(foto, knop.getAttribute('href') || info.href);

      /* onderliggend paneel */
      var id = knop.getAttribute('aria-controls');
      var paneel = id && document.getElementById(id);
      if (!paneel || !info.tegels.length) return;
      var lijst = paneel.querySelector(':scope > .header-sidebar__linklist');
      if (!lijst) return;
      var hrefs = {};
      var blok = document.createElement('div');
      blok.className = 'btol-mob__tegels';
      info.tegels.forEach(function (tg) {
        if (!tg.href) return;
        hrefs[pad(tg.href)] = true;
        var a = document.createElement('a');
        a.className = 'btol-mob__tegel';
        a.href = tg.href;
        a.appendChild(maakFoto(tg.foto));
        var s = document.createElement('span');
        var st = document.createElement('strong'); st.textContent = tg.titel; s.appendChild(st);
        if (tg.sub) { var sm = document.createElement('small'); sm.textContent = tg.sub; s.appendChild(sm); }
        a.appendChild(s);
        a.insertAdjacentHTML('beforeend', PIJL);
        blok.appendChild(a);
      });
      paneel.insertBefore(blok, lijst);

      /* losse links die al als tegel bovenaan staan, weghalen */
      Array.prototype.slice.call(lijst.children).forEach(function (sub) {
        var a = sub.querySelector(':scope > a');
        if (a && hrefs[pad(a.getAttribute('href'))]) sub.remove();
      });

      /* groepen met een eigen collectie: 'Bekijk alles' bovenaan; alleen de eerste groep staat open, zo blijft het paneel kort */
      lijst.querySelectorAll('accordion-disclosure').forEach(function (acc, nr) {
        var det = acc.querySelector('details');
        if (det && nr > 0) { det.open = false; det.setAttribute('aria-expanded', 'false'); }
        var sum = acc.querySelector('summary');
        var nest = acc.querySelector('.header-sidebar__nested-linklist');
        var href = sum && info.groepen[tekst(sum).toLowerCase()];
        if (!nest || !href || hrefs[pad(href)]) return;
        var a = document.createElement('a');
        a.href = href;
        a.className = 'link-faded-reverse btol-mob__alle';
        a.textContent = 'Bekijk alles';
        nest.insertBefore(a, nest.firstChild);
      });
    });

    /* hulpblok onderaan het hoofdpaneel */
    var hulp = document.createElement('div');
    hulp.className = 'btol-mob__hulp';
    hulp.innerHTML =
      '<p><strong>Hulp nodig bij je keuze?</strong> We helpen je graag persoonlijk verder.</p>' +
      '<div class="btol-mob__hulp-links">' +
        '<a href="mailto:info@bedtextielonline.be"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg>Mail ons</a>' +
        '<a href="/pages/contact"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12z"/></svg>Stuur een bericht</a>' +
      '</div>' +
      '<ul class="btol-mob__zeker">' +
        '<li>' + VINK + '90 dagen retour</li>' +
        '<li>' + VINK + 'Gratis verzending vanaf €75</li>' +
        '<li>' + VINK + 'Belgisch familiebedrijf</li>' +
      '</ul>';
    hoofd.parentNode.insertBefore(hulp, hoofd.nextSibling);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bouw); else bouw();
})();

/* Bedtextielonline (Claude): prijs op de knop 'Toevoegen aan winkelwagen' (productpagina en vaste balk onderaan).
   Toont de prijs van de gekozen maat x het aantal, plus wat er via 'Maak je bed compleet' is toegevoegd.
   Op smalle schermen wordt de tekst 'In winkelwagen', zodat de prijs erbij past. Uitverkocht: knop blijft ongemoeid. */
(function () {
  if (!/\/products\//.test(location.pathname)) return;
  var varianten = null;
  var bezig = false;
  var euro = function (cent) {
    try { return new Intl.NumberFormat('nl-BE', { style: 'currency', currency: 'EUR' }).format(cent / 100); }
    catch (e) { return '€ ' + (cent / 100).toFixed(2).replace('.', ','); }
  };

  fetch(location.pathname.replace(/\/$/, '') + '.js').then(function (r) { return r.json(); }).then(function (p) {
    varianten = {};
    (p.variants || []).forEach(function (v) { varianten[String(v.id)] = v.price; });
    zet();
  }).catch(function () {});

  function extras() {
    var som = 0;
    document.querySelectorAll('.btol-bu__kaart').forEach(function (k) {
      var t = k.querySelector('[data-btol-bu-toggle]');
      if (!t || t.getAttribute('aria-pressed') !== 'true') return;
      var s = k.querySelector('[data-btol-bu-select]');
      var o = s && s.options[s.selectedIndex];
      /* data-prijs staat in centen (uit Liquid), maar na een kleurwissel zet btol-globaal.js er '39,95' in */
      var dp = o ? String(o.getAttribute('data-prijs') || '') : '';
      var prijs = dp.indexOf(',') > -1 ? Math.round(parseFloat(dp.replace(/[^\d,]/g, '').replace(',', '.')) * 100) || 0 : parseInt(dp, 10) || 0;
      var a = k.querySelector('[data-btol-bu-aantal]');
      som += prijs * (a ? parseInt(a.value, 10) || 1 : 1);
    });
    return som;
  }

  function zet() {
    if (!varianten || bezig) return;
    bezig = true;
    document.querySelectorAll('buy-buttons').forEach(function (bb) {
      var form = document.getElementById(bb.getAttribute('form') || '');
      var knop = bb.querySelector('button[type="submit"]');
      if (!form || !knop) return;
      if (knop.disabled) { knop.classList.remove('btol-k-metprijs'); return; }
      var id = form.elements['id'] && form.elements['id'].value;
      var prijs = varianten[String(id)];
      if (prijs == null) return;
      var q = form.elements['quantity'];
      var aantal = q ? Math.max(1, parseInt(q.value, 10) || 1) : 1;
      var totaal = prijs * aantal + extras();
      var tekst = euro(totaal);
      var bestaand = knop.querySelector('.btol-k-prijs');
      if (bestaand && bestaand.textContent === tekst) return;
      /* staat de opbouw er al, dan alleen het bedrag vervangen (geen hertekening van de knop) */
      if (bestaand) { bestaand.textContent = tekst; return; }
      knop.classList.add('btol-k-metprijs');
      knop.innerHTML = '<span class="btol-k-lang">Toevoegen aan winkelwagen</span><span class="btol-k-kort">In winkelwagen</span><span class="btol-k-streep" aria-hidden="true"></span><span class="btol-k-prijs">' + tekst + '</span>';
    });
    bezig = false;
  }

  var wacht = null;
  function straks() { clearTimeout(wacht); wacht = setTimeout(zet, 60); }
  ['change', 'input', 'click', 'variant:change', 'product:rerender'].forEach(function (ev) { document.addEventListener(ev, straks, true); });
  if (window.MutationObserver) {
    /* Zonder flitsen: zet het thema de knoptekst terug (bij een andere maat), dan zetten we de prijs er meteen weer in,
       nog voor de browser het scherm ververst. Andere wijzigingen (aantal, extra's) mogen even wachten. */
    new MutationObserver(function () {
      if (bezig) return;
      var nodig = false;
      document.querySelectorAll('buy-buttons button[type="submit"]').forEach(function (k) { if (!k.disabled && !k.querySelector('.btol-k-prijs')) nodig = true; });
      if (nodig) zet(); else straks();
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'value', 'aria-pressed'] });
  }
})();